import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const alertVariants = cva(
  "alert relative flex w-full flex-col justify-center gap-1 px-4 py-3 text-sm has-[>[data-slot=alert-title]]:has-[>[data-slot=alert-description]]:justify-start [&>svg]:absolute [&>svg]:top-1/2 [&>svg]:left-4 [&>svg]:size-4 [&>svg]:-translate-y-1/2 [&>svg]:text-current has-[>[data-slot=alert-description]]:[&>svg]:top-3 has-[>[data-slot=alert-description]]:[&>svg]:translate-y-0 [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "",
        info: "alert-info",
        destructive: "alert-critical",
        warning: "alert-warning",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
));
Alert.displayName = "Alert";

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    data-slot="alert-title"
    className={cn("font-medium tracking-tight", className)}
    {...props}
  />
));
AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    data-slot="alert-description"
    className={cn("text-sm leading-tight", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
